export default {
    'diagram3b2-5': {
        'diagram-task': 'Why?',
        'diagram-hint': 'Reasons',
        'fixed-answer': 'The Viking Experiments looking for life on Mars concluded it was barren',
        'element_5_1': 'Did not find microbes in the soil',
        'element_5_2': 'Did not find evidence of photosynthesis',
        'element_5_3': 'Did not find organic compounds of any kind',
        'diagram-description-1': 'Added food to the soil',
        'diagram-description-2': 'Did not find microbes in the soil',
        'diagram-description-3': 'Did not find evidence of photosynthesis',
        'diagram-description-4': 'Added water to a soil sample, expecting carbon dioxide',
        'diagram-description-5': 'Got oxygen instead (not likely)',
        'diagram-description-6': 'Looked for organic compounds in the soil',
        'diagram-description-7': 'Did not find organic compounds of any kind'
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3b2/diagram5/i18n/en.js